/* eslint-disable no-shadow */
import React, { Component } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import { detect } from "detect-browser";
import { stateToMarkdown } from "draft-js-export-markdown";
import { connect } from "react-redux";
import { toggleFinishJobPostModal } from "../../actions/dashboardActions";
import FormStep from "./FormStep";
import CurrentComponent from "./CurrentComponent";
import Button from "../shared/button/Button";
import Saving from "../shared/loaders/Saving";
import ModalThankYou from "./ModalThankYou";
import { updateJobsPath } from "../../resources/ApiEndpoints";
import {
  ModalBackdrop,
  ModalWrapper,
  Form,
  CurrentComponentWrapper,
  ButtonsWrapper,
} from "./styles/form-styles";

class FinishJobPost extends Component {
  constructor(props) {
    super(props);
    const { finishJobPostData } = this.props;
    const { id, employerId, title, location, isIncomplete } = finishJobPostData;

    this.state = {
      step: 1,
      formLoading: false,
      showThankYou: !isIncomplete,
      jobId: id,
      employerId,
      jobTitle: title,
      location,
      sector: undefined,
      salaryMin: "",
      salaryMax: "",
      description: undefined,
      benefits: [],
      jobType: "permanent",
      salaryType: "fixed",
      errors: {},
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ formLoading: true });

    const {
      jobId,
      employerId,
      jobTitle,
      location,
      sector,
      salaryMin,
      salaryMax,
      description,
      benefits,
      jobType,
      salaryType,
    } = this.state;

    axios({
      method: "patch",
      url: updateJobsPath(jobId),
      data: {
        employer_id: employerId,
        title: jobTitle,
        location,
        sector_id: sector,
        salary_min: salaryMin,
        salary_max: salaryMax,
        description,
        benefit_ids: benefits,
        job_type: jobType,
        salary_type: salaryType,
      },
    }).then(() => {
      this.setState({ formLoading: false, showThankYou: true });
    });
  };

  handleTextInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  descriptionEditorOnChange = (state) => {
    const markdownState = stateToMarkdown(state.getCurrentContent());

    this.setState({ description: markdownState });
  };

  handleBenefits = (e) => {
    const { benefits } = this.state;

    if (e.target.checked) {
      this.setState({ benefits: [...benefits, parseInt(e.target.id, 10)] });
    } else {
      this.setState({
        benefits: benefits.filter(
          (benefit) => benefit !== parseInt(e.target.id, 10)
        ),
      });
    }
  };

  handleJobType = (e) => {
    this.setState({ jobType: e.target.id });
    if (e.target.id === "contract") this.setState({ salaryType: "fixed" });
    if (e.target.id === "permanent") this.setState({ salaryType: "fixed" });
  };

  handleSalaryType = (e) => {
    this.setState({ salaryType: e.target.id });
    if (e.target.id === "fixed") this.setState({ salaryMax: undefined });
  };

  handleNext = (e) => {
    e.preventDefault();
    const {
      jobTitle,
      location,
      sector,
      salaryMin,
      salaryMax,
      step,
      salaryType,
    } = this.state;

    const stepOneFields = {
      jobTitle,
      location,
      sector,
      salaryMin,
    };

    if (salaryType === "range") {
      Object.assign(stepOneFields, { salary_max: salaryMax });
    }

    const newErrors = {};

    if (step === 1) {
      Object.keys(stepOneFields).forEach((fieldKey) => {
        if (!stepOneFields[fieldKey]) {
          newErrors[fieldKey] = "Required field.";
        }
      });
    }

    if (Object.keys(newErrors).length < 1) {
      this.setState(({ step }) => ({ step: step + 1 }));
      this.setState({ errors: {} });
    } else {
      this.setState({ errors: newErrors });
    }
  };

  handlePrev = (e) => {
    e.preventDefault();
    this.setState(({ step }) => ({ step: step - 1 }));
  };

  render() {
    const { step, formLoading, showThankYou } = this.state;
    const iOS = detect().name === "ios";
    const { finishJobPostData } = this.props;
    const { id: jobId, scheduleCallLink } = finishJobPostData;

    return (
      <ModalBackdrop className="animated fadeIn">
        <ModalWrapper iOS={iOS} className="animated fadeInDown">
          {formLoading && <Saving darkPurple />}
          {showThankYou && (
            <ModalThankYou
              purple
              scheduleCallLink={scheduleCallLink}
              jobId={jobId}
            />
          )}
          <FormStep step={step} />
          <Form iOS={iOS}>
            <CurrentComponentWrapper iOS={iOS}>
              <CurrentComponent
                {...this.state}
                handleTextInput={this.handleTextInput}
                descriptionEditorOnChange={this.descriptionEditorOnChange}
                finishJobPostData={finishJobPostData}
                handleBenefits={this.handleBenefits}
                handleJobType={this.handleJobType}
                handleSalaryType={this.handleSalaryType}
              />
            </CurrentComponentWrapper>
            <ButtonsWrapper iOS={iOS}>
              {step > 1 && (
                <Button
                  secondaryWhite
                  iOS={iOS}
                  noFocus
                  buttonName="Previous"
                  onClickAction={this.handlePrev}
                />
              )}
              {step < 3 && (
                <Button
                  id="button-next"
                  primary
                  noFocus
                  iOS={iOS}
                  firstStep={step === 1}
                  buttonName="Next"
                  onClickAction={this.handleNext}
                />
              )}
              {step === 3 && (
                <Button
                  primary
                  iOS={iOS}
                  buttonName="Save"
                  noFocus
                  onClickAction={this.handleSubmit}
                />
              )}
            </ButtonsWrapper>
          </Form>
        </ModalWrapper>
      </ModalBackdrop>
    );
  }
}

FinishJobPost.propTypes = {
  toggleFinishJobPostModal: PropTypes.func.isRequired,
  finishJobPostData: PropTypes.shape({
    id: PropTypes.string,
    employerId: PropTypes.number,
    title: PropTypes.string,
    jobTitle: PropTypes.string,
    location: PropTypes.string,
    salaryMin: PropTypes.number,
    scheduleCallLink: PropTypes.string,
    isIncomplete: PropTypes.bool,
  }),
};

FinishJobPost.defaultProps = {
  finishJobPostData: PropTypes.shape({
    scheduleCallLink: PropTypes.isNull,
    id: PropTypes.string,
    employerId: PropTypes.number,
    title: PropTypes.string,
    location: PropTypes.string,
    isIncomplete: PropTypes.bool,
  }).isRequired,
};

export default connect(null, { toggleFinishJobPostModal })(FinishJobPost);
